import React, { useState } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useMutation } from '@apollo/client';

import CancelModal from './CancelModal';
import Money from 'core/api/Money';
import { PRODUCT_TEMP } from 'core/assets/images/V2';
import { Box, Button, Flex, Image } from 'core/ui/atoms';
import { UPDATE_USER_OTP_SUBSCRIPTION_STATUS } from 'core/api/apollo/mutations';
import ResponsiveView from 'core/ui/components/ResponsiveView';

const SubscriptionItem = ({ item, refetch }) => {
  const { programType, subscriptionActive, mealType, bundlePrice } = item;
  const { name, availableDeliveryDays, schedule } = item?.programBundle || {};

  // eslint-disable-next-line no-console
  console.log('item', item);

  const [openCancelModal, setOpenCancelModal] = useState(false);

  const [updateUserOtpSubscription] = useMutation(UPDATE_USER_OTP_SUBSCRIPTION_STATUS, {
    onCompleted: async (data) => {
      // eslint-disable-next-line no-console
      console.log('User OTP cancelled successfully:', data);
      refetch();
      setOpenCancelModal(false);
    },
    onError: (error) => {
      // eslint-disable-next-line no-console
      console.error('Error cancelling user OTP:', error);
    },
  });

  const handleCancellation = async () => {
    try {
      await updateUserOtpSubscription({
        variables: {
          input: {
            status: 'cancelled',
          },
        },
      });
      refetch();
    } catch (error) {
      console.error('Failed to update quantity:', error);
    }
  };

  return (
    <ProductContainer>
      <ItemContainer direction='row' justifyContent='start'>
        <SelectCont>
          <ProductImage src={PRODUCT_TEMP} alt={name} />
        </SelectCont>
        <DetailsContainer>
          <Flex direction='row' justifyContent='space-between' alignItems='center'>
            <ProductName>{programType}</ProductName>
            <ResponsiveView desktop={false}>
              <ProducAmount>{Money(bundlePrice).toFormat('$0,0')}/week</ProducAmount>
            </ResponsiveView>
          </Flex>
          <ProductDescription>{mealType}</ProductDescription>
          <ProductDescription>Subscription | {schedule?.name}/ Week</ProductDescription>
          <ProductDescription>Start Date : {moment(availableDeliveryDays[0]?.date).format('DD-MM-YYYY')}</ProductDescription>
        </DetailsContainer>
        <ResponsiveView desktop={true}>
          <ProductName>{Money(bundlePrice).toFormat('$0,0')}/week</ProductName>
        </ResponsiveView>
      </ItemContainer>
      {subscriptionActive !== null &&
        <CancelButton
          disabled={!subscriptionActive}
          btn-link
          onClick={() => setOpenCancelModal(true)}>
          {subscriptionActive ? 'CANCEL SUBSCRIPTION' : 'SUBSCRIPTION CANCELLED'}
        </CancelButton>
      }
      {openCancelModal &&
        <CancelModal
          handleSubmit={() => handleCancellation()}
          closeModal={() => setOpenCancelModal(false)}
        />
      }
    </ProductContainer>
  );
};

SubscriptionItem.propTypes = {
  item: PropTypes.object.isRequired,
  refetch: PropTypes.func,
};

const ItemContainer = styled(Flex)`
  width: 100%;
`;

const CancelButton = styled(Button)`
  color: ${(p) => p.theme.colors.primaryV2};
  text-align: center;
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  margin-top: 10px;
  text-decoration: underline;
  text-underline-offset: 5px;
`;

const ProductImage = styled(Image)`
  height: 94px;
  width: 94px;
  object-fit: cover;
`;

const SelectCont = styled.div`
  position: relative;
  width: 40%;
  display: flex;
  justify-content: end;
  flex-shrink: 0;
  margin-right: 10px;
  &:last-child {
    margin-right: 0;
  }
  ${(p) => p.theme.max('sm')`
    width: 28%;
  `}
`;

const ProductContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 44px;
`;

const DetailsContainer = styled(Box)`
  width: 28%;
  ${(p) => p.theme.max('sm')`
    width: 60%;
  `}
`;

const ProductName = styled.p`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

const ProducAmount = styled.p`
  font-family: ${({ theme }) => theme.typography.familyLarken};
  font-size: 16px;
  line-height: 22px;
  margin: 0px;
  color: ${(p) => p.theme.colors.primaryV2};
  ${(p) => p.theme.max('sm')`
    text-align: end;
  `}
`;

const ProductDescription = styled.p`
  font-family: ${({ theme }) => theme.typography.familyPoppins};
  font-weight: 400;
  font-size: 12px;
  margin: 0px;
  margin-top: 2px;
  color: ${(p) => p.theme.colors.primaryV2};
`;

export default SubscriptionItem;
